import { BuyerSurveyResponse } from '../interfaces/survey.interface';

export class McSvpParentChildSegregator {
  constructor(private readonly _surveys: BuyerSurveyResponse[]) {}

  public parent(): BuyerSurveyResponse {
    return this._surveys.find((s) => s.mc && s.mc.SVP && s.mc.parent)!;
  }

  public childs(): BuyerSurveyResponse[] {
    return this._surveys.filter((s) => s.mc && s.mc.SVP && !s.mc.parent)!;
  }
}
